import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cleaning"
const CleaningIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.383 1.892C10.581 1.413 11.13 1.186 11.608 1.383 12.086 1.581 12.314 2.13 12.116 2.608L7.862 12.888C9.809 13.383 11.25 15.148 11.25 17.25 11.25 18.682 11.74 19.562 12.25 20.106 12.777 20.668 13.368 20.916 13.6 20.996 14.101 21.17 14.143 21.66 14.106 21.864S13.864 22.5 13.348 22.5H2.691C1.998 22.5 1.469 21.876 1.582 21.19L2.253 17.176C2.286 15.03 3.823 13.249 5.858 12.839Q5.869 12.802 5.883 12.767zM6.75 14.25C5.093 14.25 3.75 15.593 3.75 17.25V17.312L3.74 17.372 3.135 21H11.037C10.324 20.182 9.75 18.974 9.75 17.25 9.75 15.593 8.407 14.25 6.75 14.25"
            clipRule="evenodd"
          />
          <path d="M21.75 21C22.164 21 22.5 21.336 22.5 21.75S22.164 22.5 21.75 22.5H16.5C16.086 22.5 15.75 22.164 15.75 21.75S16.086 21 16.5 21zM20.25 16.875C20.664 16.875 21 17.21 21 17.625S20.664 18.375 20.25 18.375H15C14.586 18.375 14.25 18.039 14.25 17.625S14.586 16.875 15 16.875zM18 13.5C18.414 13.5 18.75 13.836 18.75 14.25S18.414 15 18 15H13.5C13.086 15 12.75 14.664 12.75 14.25S13.086 13.5 13.5 13.5z" />
        </svg>
      }
    </span>
  )
}
export default CleaningIcon
